export class XylophoneTable extends Phaser.GameObjects.Graphics {
  constructor(scene, x, y) {
    super(scene, x, y);
    scene.add.existing(this);

    this.fillStyle(0x4a7caf);
    this.fillEllipse(0, 35, 1735, 975, 64);
    this.fillStyle(0x1d4771);
    this.fillEllipse(0, 0, 1735, 975, 64);
    this.setPosition(x, y);
  }
}
